const GraphPrefix = require('./GraphPrefix');
const { query } = require('@simpleview/sv-graphql-client');

class UsersPrefix extends GraphPrefix {
	constructor({ graphUrl, graphServer }) {
		super({ name: 'users', graphUrl, graphServer });
	}

	async fetchInitialData({ context, restrictToUser }){
		context = context || this._graphServer.context;
		const variables = {
			acct_id : context.legacy.user.permalink,
			user_id : parseInt(context.legacy.user.id)
		}

		let userIdFilter = ``;

		if (restrictToUser.user_id !== -1) {
			userIdFilter = `(filter : { user_id : ${restrictToUser.user_id}})`;
		}

		const result = await query({
			query : `
				query ($acct_id : String! $user_id : Int!) {
					bbs (input : { acct_id : $acct_id }) {
						asset_categories ${userIdFilter} {
							success
							message
							docs {
								id
								name
								type
								children
							}
						}
						access_groups (
							filter : { admin: false, active: true }
							options : { limit: 1000, sort: null }
						){
							success
							message
							docs {
								id
								name
							}
						}
						asset_types {
							success
							message
							docs {
								id
								label
							}
						}
						collections(
							filter : { user_id : $user_id, active : true }
							options : { limit : 9999, sort : { field_name : title, direction : asc } }
						) {
							success
							message
							docs {
								id
								title
							}
						}
					}
				}
			`,
			variables,
			url : this._graphUrl,
			token : context.token,
		});

		return result;
	}

}

module.exports = UsersPrefix;